import { deprecatedMakeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

const useStyles = deprecatedMakeStyles()((theme) => ({
	container: {
		height: '150px',
		position: 'relative',
		[theme.breakpoints.up(theme.breakpoints.values.sm)]: {
			height: '210px',
		},
	},
	headerImageContainer: {
		overflow: 'hidden',
		height: '100%',
		width: '100%',
		backgroundColor: theme.palette.grey[200],

		'& span': {
			width: '100% !important',
			height: '100% !important',
			top: '50% !important',
			left: '50% !important',
			overflow: 'visible !important',
			transform: 'translate(-50%, -50%)',
		},
	},
	headerImage: {
		borderRadius: theme.shape.borderRadius - 2,
		bottom: 'auto !important',
		right: 'auto !important',
		top: '50% !important',
		left: '50% !important',
		objectFit: 'cover',
		objectPosition: '0 50%',
		width: '100%',

		[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
			borderRadius: 0,
		},
	},
}));

export default useStyles;
